import React, { useState, useEffect } from 'react';
import { countryCache, onCountriesLoaded } from '../../utils/countries';
import CountryFlag from './CountryFlag';

/**
 * Render a player's profile flag by steamid64, resolved from the shared country
 * cache (see ``utils/countries.js``). Renders nothing until/unless a country is
 * known for that id, and re-renders when a bulk fetch resolves. Use on any
 * steamid-keyed surface (scoreboards, leaderboards) after calling
 * ``fetchCountriesBulk`` with the visible steamids.
 *
 * @param {object} props - Component props.
 * @param {string|number} props.steamid64 - The player's Steam ID.
 * @param {string} [props.size='sm'] - CountryFlag size (sm|md|lg).
 * @param {string} [props.className] - Extra class for spacing.
 * @param {function} [props.onClick] - Optional click handler. When given, the
 *   flag is wrapped in a clickable span (e.g. to open the player's profile).
 */
const SteamFlag = ({ steamid64, size = 'sm', className = '', onClick }) => {
  const [, forceUpdate] = useState(0);

  useEffect(() => {
    const unsubscribe = onCountriesLoaded(() => forceUpdate((n) => n + 1));
    return unsubscribe;
  }, []);

  const code = steamid64 != null ? countryCache[steamid64] : null;
  if (!code) return null;
  const flag = <CountryFlag code={code} size={size} className={className} />;
  if (!onClick) return flag;
  return (
    <span className="steam-flag-click" onClick={onClick}>
      {flag}
    </span>
  );
};

export default SteamFlag;
